module.exports = __webpack_public_path__ + "static/hollywood-room-1-71c8d18272829888a0498ad2a0fa7a4b.jpg";